<input
    type="file"
    class="file-input"
    (change)="onFileSelected($event)"
    [multiple]="isMultiple"
    [accept]="requiredFileType"
    #fileUpload
/>
<div>
    <div
        class="file-upload"
        [class.file-error]="isErroring"
        (click)="fileUpload.click()"
    >
        <h6 class="file-label">{{ label }}</h6>
        {{ fileName || "No file uploaded yet." }}
        <mat-icon>attach_file</mat-icon>
    </div>
    <div class="error">
        <mat-error *ngIf="isErroring" class="error">
            {{ errorMessage }}
        </mat-error>
    </div>
</div>
